import {
  THREE,
  GemChecker,
  BrowserInfo
} from 'GT3DEngine-module'

export default class GT3DBaseView {
  constructor(options) {
    const defaultOptions = {
      width: window.innerWidth,
      height: window.innerHeight,
      element: document.body,
      pixelRatio: window.devicePixelRatio,
      alpha: true,
      antialias: true,
      debugMode: false
    }
    this.options = Object.assign({}, defaultOptions, options)
    console.log('options:', this.options)
    this.initParams()
    this.initRenderer()
    this.initScene()
    this.initCamera()
    this.initLights()
    this.initLoadingManager()
    this.initLoader()
    this.initControls()
    this.initOrientation()
    this.initGemChecker()
    this.onInitialized()
    this.startAnimationFrame()
  }

  initParams() {
    this.clock = new THREE.Clock()
    this.animate = this.animate.bind(this)
    this.browserInfo = new BrowserInfo()
  }

  initRenderer() {
    let canvas = document.createElement('canvas')
    let context = canvas.getContext('webgl2')
    const renderer = this.renderer = new THREE.WebGLRenderer({
      canvas: canvas,
      context: context,
      alpha: this.options.alpha,
      antialias: this.options.antialias
    })
    renderer.setSize(this.options.width, this.options.height)
    renderer.setPixelRatio(this.options.pixelRatio)
    this.options.element.appendChild && this.options.element.appendChild(renderer.domElement)
  }

  initScene() {
    this.scene = new THREE.Scene()
    // scene.background = new Color(0xaaaaaa)
  }

  initCamera() {
    const camera = this.camera = new THREE.PerspectiveCamera(50, this.options.width / this.options.height, 0.1, 10000)
    camera.position.set(1000, 1000, 1000)
    camera.lookAt(new THREE.Vector3(0, 0, 0))
    // this.scene.add(camera)
  }

  initLights() {}

  initLoadingManager() {
    this.manager = THREE.DefaultLoadingManager
  }

  initLoader() {
    this.loader = new THREE.GT3DLoader(this.manager)
  }

  initControls() {
    this.controls = new THREE.OrbitControls(this.camera, this.renderer.domElement)
    this.controls.screenSpacePanning = true;
  }

  initOrientation() {
    this.onOrientationChange = this.onOrientationChange.bind(this)
    this.onOrientationChange()
    window.addEventListener('orientationchange', this.onOrientationChange, false)
  }

  initGemChecker() {
    let baseUrl = this.ensureBaseUrl()
    this.gemChecker = new GemChecker(baseUrl, this.renderer)
  }

  onInitialized() {
    console.log('onInitialized.')
  }

  onOrientationChange() {
    console.log('onOrientationChange: ', window.orientation)
  }

  onResize() {
    let width = this.options.element.offsetWidth;
    let height = this.options.element.offsetHeight;
    if (this.options.width === width && this.options.height === height)
      return false;
    console.log('onResize: ', width, height)
    this.options.width = width;
    this.options.height = height;

    if (this.camera) {
      if (this.camera.isPerspectiveCamera)
        this.camera.aspect = width / height;
      else if (this.camera.isOrthographicCamera) {
        this.camera.left = -width / 2;
        this.camera.right = width / 2;
        this.camera.top = height / 2;
        this.camera.bottom = -height / 2;
      }
      this.camera.updateProjectionMatrix();
    }

    if (this.renderer)
      this.renderer.setSize(width, height);
    if (this.composer)
      this.composer.setSize(width, height);
    if (this.fxaaPass) {
      let pixelRatio = this.renderer.getPixelRatio();
      this.fxaaPass.material.uniforms['resolution'].value.x = 1 / (width * pixelRatio);
      this.fxaaPass.material.uniforms['resolution'].value.y = 1 / (height * pixelRatio);
    }

    return true;
  }

  animate() {
    if (this._stopAnimationFrameFlag)
      return;
    window.requestAnimationFrame(this.animate)
    this.onResize()
    if (this.controls && this.controls.enabled && this.controls.autoRotate && this.controls.update)
      this.controls.update()
    if (this.mixers) {
      // 更新混合器相关的时间
      let delta = this.clock.getDelta()
      for (let i = 0; i < this.mixers.length; i++) {
        this.mixers[i].update(delta)
      }
    }
    this.onFrameUpdate()
    this.render()
  }

  onFrameUpdate() {}

  render() {
    if (this.composer)
      this.composer.render()
    else
      this.renderer.render(this.scene, this.camera)
  }

  computeObjectBoundingBox(object) {
    if (object) {
      let box = new THREE.Box3();
      box.setFromObject(object);
      return box;
    } else {
      console.warn('computeObjectBoundingBox error, the object is null.');
      return null;
    }
  }

  computeObjectCenter(object) {
    if (object) {
      let box = this.computeObjectBoundingBox(object);
      let result = new THREE.Vector3();
      box.getCenter(result);
      return result;
    } else {
      console.warn('computeObjectCenter error, the object is null.');
      return null;
    }
  }

  ensureBaseUrl() {
    let baseUrl = this.options.baseUrl
    if (baseUrl === undefined) {
      baseUrl = window.location.origin
      if (baseUrl.match('192.168.') || baseUrl.match('127.0.'))
        baseUrl = 'http://t.p.gemtec.ltd'
      this.options.baseUrl = baseUrl
      console.log('ensureBaseUrl:', baseUrl);
    }
    return baseUrl
  }

  ensureCameraFocus(object, camera, controls, factor) {
    if (!object) {
      console.warn('ensureCameraFocus object is undefined.');
      return;
    }
    if (factor === undefined)
      factor = 0.5;
    let box = new THREE.Box3().setFromObject(object);
    let size = box.getSize(new THREE.Vector3()).length();
    let center = box.getCenter(new THREE.Vector3());
    if (camera && camera.isPerspectiveCamera) {
      camera.position.copy(center);
      camera.position.x += size * factor;
      camera.position.y += size * factor;
      camera.position.z += size * factor;
      camera.lookAt(center);
    }
    if (controls) {
      controls.target.copy(center);
      controls.update();
    }
  }

  ensureSceneLight(scene) {
    if (!scene) {
      console.warn('ensureSceneLight the scene is undefined.');
      return;
    }
    let hasLight = false;
    scene.traverse((child) => {
      if (child.isLight)
        hasLight = true;
    });
    if (hasLight === false) {
      console.log('hasLight is false, add default AmbientLight.');
      scene.add(new THREE.AmbientLight(0xffffff, 1.0));
    }
  }

  /**
   * [loadScene description]
   * @param  {[type]} url        [description]
   * @param  {[type]} onLoad     [description]
   * @param  {[type]} onProgress [description]
   * @param  {[type]} onError    [description]
   * @return {[type]}            [description]
   */
  loadScene(url, onLoad, onProgress, onError, scene, camera, controls) {
    if (this.isDestroyed)
      return;
    return new Promise((resolve, reject) => {
      if (!url) {
        let error = 'the url is undefined.';
        console.error(error);
        if (onError)
          onError(error);
        reject(error);
        return;
      }
      if (url.startsWith('http://img2.tutubox.cn')) {
        url = url.replace('http://img2.tutubox.cn', 'https://img2.tutubox.cn');
      }
      console.log('loadScene: ', url);
      this.loader.load(url, (result, gt3dData, others) => {
        if (this.isDestroyed)
          return;
        if (!gt3dData)
          gt3dData = {};
        if (!scene)
          scene = this.scene;
        if (!camera)
          camera = this.camera;
        if (!controls)
          controls = this.controls;
        this.parseResult(result, gt3dData.custom, others, scene, camera, controls).then(() => {
          if (this.isDestroyed)
            return;
          if (gt3dData && gt3dData.type === 'three-scene-config') {
            if (gt3dData.model && gt3dData.model.materials) {
              this.loadMaterialsToScene(gt3dData.model.materials, () => {
                this.gemChecker.checkAndMakeDiamonds(scene);
                if (onLoad)
                  onLoad(result, gt3dData.custom, others);
                resolve({
                  result: result,
                  custom: gt3dData.custom,
                  others: others
                });
              }, undefined, undefined, scene);
            }
          } else {
            this.gemChecker.checkAndMakeDiamonds(scene);
            if (onLoad)
              onLoad(result, gt3dData.custom, others);
            resolve({
              result: result,
              custom: gt3dData.custom,
              others: others
            });
          }
        });
      }, onProgress, onError);
    });
  }

  /**
   * [parseResult description]
   * @param  {[type]} result     [description]
   * @param  {[type]} custom     [description]
   * @param  {[type]} others     [description]
   * @param  {[type]} onFinished [description]
   * @param  {[type]} scene      [description]
   * @param  {[type]} camera     [description]
   * @param  {[type]} controls   [description]
   * @return {[type]}            [description]
   */
  parseResult(result, custom, others, scene, camera, controls) {
    return new Promise((resolve, reject) => {
      if (result && scene) {
        if (result instanceof THREE.Scene) {
          while (result.children && result.children.length > 0)
            scene.add(result.children.pop());
        } else {
          scene.add(result);
        }
      }
      if (custom && JSON.stringify(custom) !== '{}') {
        // console.log('custom: ', custom);
        this.parseUserData(custom, scene, camera, controls);
      } else if (result && result.userData) {
        // console.log('userData: ', result.userData);
        custom = result.userData;
        this.parseUserData(result.userData, scene, camera, controls);
      }
      if (others) {
        if (others.animations && others.animations.length > 0) {
          if (scene) {
            scene.animations = others.animations;
          } else {
            object.animations = others.animations;
          }
        }
      }
      if (scene) {
        this.ensureSceneLight(scene);
      }
      resolve();
    });
  }

  /**
   * [parseUserData description]
   * @param  {[type]} userData [description]
   * @param  {[type]} scene    [description]
   * @param  {[type]} camera   [description]
   * @param  {[type]} controls [description]
   * @return {[type]}          [description]
   */
  parseUserData(userData, scene, camera, controls) {
    console.log('parseUserData: ', userData);
    let hasCameraData = false;
    //设置相机
    if (camera && userData.camera) {
      let sceneCamera = this.loader.parseObject(userData.camera);
      if (sceneCamera.type === camera.type) {
        // console.log('sceneCamera: ', sceneCamera);
        let aspect = camera.aspect;
        camera.copy(sceneCamera);
        camera.aspect = aspect;
        camera.updateProjectionMatrix();
        hasCameraData = true;
      }
    }
    //设置相机控制器
    if (controls) {
      if (userData.cameraControls) {
        if (userData.cameraControls.center)
          controls.target.fromArray(userData.cameraControls.center);
        if (userData.cameraControls.minPolarAngle)
          controls.minPolarAngle = userData.cameraControls.minPolarAngle;
        if (userData.cameraControls.maxPolarAngle)
          controls.maxPolarAngle = userData.cameraControls.maxPolarAngle;
        if (userData.cameraControls.minAzimuthAngle)
          controls.minAzimuthAngle = userData.cameraControls.minAzimuthAngle;
        if (userData.cameraControls.maxAzimuthAngle)
          controls.maxAzimuthAngle = userData.cameraControls.maxAzimuthAngle;
      } else if (userData.controlsCenter) {
        controls.target.fromArray(userData.controlsCenter);
      }
      if (camera && userData.cameraControls) {
        let distance = camera.position.distanceTo(controls.target);

        let minDistance = distance * 0.5;
        if (userData.cameraControls.minDistance) {
          minDistance = distance * userData.cameraControls.minDistance;
        }
        controls.minDistance = minDistance;

        let maxDistance = distance * 2;
        if (userData.cameraControls.maxDistance) {
          maxDistance = distance * userData.cameraControls.maxDistance;
        }
        controls.maxDistance = maxDistance;
      }
      if (controls.update !== undefined)
        controls.update();
    }
    //设置场景背景
    if (scene && userData.background) {
      // console.log('background: ', userData.background);
      if (Number.isInteger(userData.background)) {
        scene.background = new THREE.Color(userData.background);
      } else {
        this.loader.parseTexture(userData.background, (texture) => {
          scene.background = texture;
        });
      }
    }
    //设置场景雾化
    if (scene && userData.fog) {
      if (userData.fog.type === 'Fog') {
        scene.fog = new THREE.Fog(userData.fog.color, userData.fog.near, userData.fog.far);
      } else if (userData.fog.type === 'FogExp2') {
        scene.fog = new THREE.FogExp2(userData.fog.color, userData.fog.density);
      }
    }
    //配置后处理
    if (userData.postProcessing) {
      if (userData.postProcessing.antialias && userData.postProcessing.antialias.enabled) {
        this.ensureFXAAPass();
      }
      if (userData.postProcessing.bloom && userData.postProcessing.bloom.enabled) {
        this.ensureBloomPass();
        if (userData.postProcessing.bloom.threshold !== undefined)
          this.bloomPass.threshold = userData.postProcessing.bloom.threshold;
        if (userData.postProcessing.bloom.strength !== undefined)
          this.bloomPass.strength = userData.postProcessing.bloom.strength;
        if (userData.postProcessing.bloom.radius !== undefined)
          this.bloomPass.radius = userData.postProcessing.bloom.radius;
      }
    }
    if (!hasCameraData && camera && camera.isPerspectiveCamera) {
      this.ensureCameraFocus(scene, camera, controls);
    }
  }

  ensureComposer() {
    if (!this.composer) {
      this.composer = new THREE.EffectComposer(this.renderer);
      let width = this.options.width;
      let height = this.options.height;
      this.composer.setSize(width, height);
      let renderPass = new THREE.RenderPass(this.scene, this.camera);
      this.composer.addPass(renderPass);
      console.log('ensureComposer: ', this.composer);
    }
  }

  ensureFXAAPass() {
    if (this.browserInfo && this.browserInfo.isMobile) {
      console.warn('the platform is mobile, not support fxaa.');
      return;
    }
    if (!this.fxaaPass) {
      this.fxaaPass = new THREE.ShaderPass(THREE.FXAAShader);
      let width = this.options.width;
      let height = this.options.height;
      let pixelRatio = this.renderer.getPixelRatio();
      this.fxaaPass.material.uniforms['resolution'].value.x = 1 / (width * pixelRatio);
      this.fxaaPass.material.uniforms['resolution'].value.y = 1 / (height * pixelRatio);
      this.ensureComposer();
      this.composer.addPass(this.fxaaPass);
      console.log('ensureFXAAPass: ', this.fxaaPass);
    }
  }

  ensureBloomPass() {
    if (!this.bloomPass) {
      let width = this.options.width;
      let height = this.options.height;
      this.bloomPass = new THREE.UnrealBloomPass(new THREE.Vector2(width, height), 0, 0, 0);
      this.ensureComposer();
      this.composer.addPass(this.bloomPass);
      console.log('ensureBloomPass: ', this.bloomPass);
    }
  }

  /**
   * [loadMaterialsToScene description]
   * @param  {[type]} url        [description]
   * @param  {[type]} onLoad     [description]
   * @param  {[type]} onProgress [description]
   * @param  {[type]} onError    [description]
   * @param  {[type]} scene      [description]
   * @return {[type]}            [description]
   */
  loadMaterialsToScene(url, onLoad, onProgress, onError, scene) {
    if (this.isDestroyed)
      return;
    return new Promise((resolve, reject) => {
      if (!url) {
        let error = 'the url is undefined.';
        console.error(error);
        if (onError)
          onError(error);
        reject(error);
        return;
      }
      if (!scene)
        scene = this.scene;
      if (url.startsWith('http://img2.tutubox.cn')) {
        url = url.replace('http://img2.tutubox.cn', 'https://img2.tutubox.cn');
      }
      console.log('loadMaterialsToScene: ', url);
      let loader = new THREE.GT3DMaterialLoader();
      loader.useStreamParse = true;
      loader.load(url, (material, index, length) => {
        if (this.isDestroyed) {
          loader.dispose();
          return;
        }
        if (material && material.isMaterial)
          this.setMaterialToScene(material, scene);
        else if (index !== undefined && length !== undefined && index === length) {
          if (onLoad)
            onLoad(material);
          resolve(material);
        } else {
          if (onLoad)
            onLoad(material);
          resolve(material);
        }
      }, onProgress, onError);
    });
  }

  /**
   *[setMaterialToScene description]
   * @param {[type]} material [description]
   * @param {[type]} scene    [description]
   */
  setMaterialToScene(material, scene) {
    // console.log('setMaterialToScene: ', material, scene);
    return new Promise((resolve, reject) => {
      if (!material || !scene) {
        let msg = 'the material or scene is undefined.';
        console.warn(msg);
        reject(msg);
        return;
      }
      scene.traverse((child) => {
        if (child.material) {
          if (Array.isArray(child.material)) {
            for (let i = child.material.length - 1; i >= 0; i--) {
              if (child.material[i].uuid === material.uuid) {
                child.material[i].dispose();
                child.material[i] = material;
              }
            }
          } else if (child.material.uuid === material.uuid) {
            child.material.dispose();
            child.material = material;
          }
        }
      });
      resolve();
    });
  }

  /**
   * [setMaterialsToScene description]
   * @param {[type]} materials [description]
   * @param {[type]} scene     [description]
   */
  setMaterialsToScene(materials, scene) {
    return new Promise((resolve, reject) => {
      if (!materials || !scene) {
        let msg = 'the materials or scene is undefined.';
        console.warn(msg);
        reject(msg);
        return;
      }
      scene.traverseVisible((child) => {
        if (child.material) {
          if (Array.isArray(child.material)) {
            for (let i = child.material.length - 1; i >= 0; i--) {
              if (materials[child.material[i].uuid]) {
                child.material[i].dispose();
                child.material[i] = materials[child.material[i].uuid];
              }
            }
          } else {
            if (materials[child.material.uuid]) {
              child.material.dispose();
              child.material = materials[child.material.uuid];
            }
          }
        }
      });
      resolve();
    });
  }

  //开始渲染动画帧
  startAnimationFrame() {
    if (this._stopAnimationFrameFlag === undefined || this._stopAnimationFrameFlag === true) {
      console.log('startAnimationFrame');
      this._stopAnimationFrameFlag = false;
      this.animate();
    }
  }

  //停止渲染动画帧
  stopAnimationFrame() {
    if (this._stopAnimationFrameFlag === false) {
      console.log('stopAnimationFrame');
      this._stopAnimationFrameFlag = true;
    }
  }

  initAnimations() {
    if (this.isDestroyed)
      return;
    this.animationRoots = []
    this.mixers = []
    this.actions = {}
    this.scene.traverse((child) => {
      if (child.animations && child.animations.length > 0) {
        this.animationRoots.push(child)
        let mixer = new THREE.AnimationMixer(child)
        child.mixer = mixer
        mixer.actions = {}
        for (let i = 0; i < child.animations.length; i++) {
          let action = mixer.clipAction(child.animations[i])
          mixer.actions[child.animations[i].name] = action
          this.actions[child.animations[i].name] = action
        }
        this.mixers.push(mixer)
      }
    })
  }

  uncacheAnimations() {
    if (this.mixers) {
      for (let i = this.mixers.length - 1; i >= 0; i--) {
        let mixer = this.mixers[i]
        if (mixer.actions) {
          Object.keys(mixer.actions).forEach((key) => {
            let action = mixer.actions[key]
            action.stop()
            mixer.uncacheAction(action)
            mixer.uncacheClip(action.getClip())
          })
          mixer.actions = null
        }
        mixer.uncacheRoot(mixer.getRoot())
        mixer.removeAllEventListener()
      }
    }
    this.mixers = null
    this.actions = null
    this.animationRoots = null
  }

  getAnimationRoots() {
    return this.animationRoots
  }

  getAnimationMixers() {
    return this.mixers
  }

  getAnimationAction(name, root) {
    if (root && root.mixer) {
      return root.mixer.actions[name]
    }
    if (this.actions)
      return this.actions[name]
    return undefined
  }

  playAnimation(name, params, onFinished, root) {
    let action = this.getAnimationAction(name, root)
    if (action) {
      if (params) {
        if (params.loop !== undefined)
          action.loop = params.loop
        if (params.clampWhenFinished !== undefined)
          action.clampWhenFinished = params.clampWhenFinished
        if (params.repetitions !== undefined)
          action.repetitions = params.repetitions
      }
      if (onFinished) {
        let finishedListener = function(event) {
          if (event.action === action) {
            console.log('finished: ', event)
            action.getMixer().removeEventListener('finished', finishedListener)
            onFinished(action)
          }
        }
        action.getMixer().addEventListener('finished', finishedListener)
      }
      action.stop()
      action.play()
    } else {
      console.warn('un finded animation in name:', name)
    }
  }

  stopAnimation(name, root) {
    let action = this.getAnimationAction(name, root)
    if (action) {
      action.stop()
    } else {
      console.warn('un finded animation in name:', name)
    }
  }

  pauseAnimation(name, root) {
    let action = this.getAnimationAction(name)
    if (action) {
      action.paused = true
    } else {
      console.warn('un finded animation in name:', name)
    }
  }

  resumeAnimation(name, root) {
    let action = this.getAnimationAction(name)
    if (action) {
      action.paused = false
    } else {
      console.warn('un finded animation in name:', name)
    }
  }

  stopAllAnimations() {
    if (this.mixers) {
      for (let i = this.mixers.length - 1; i >= 0; i--) {
        let mixer = this.mixers[i]
        if (mixer.actions) {
          Object.keys(mixer.actions).forEach((key) => {
            let action = mixer.actions[key]
            action.stop()
          })
        }
      }
    }
  }

  dispose() {

    console.log('dispose execute.')

    this.isDestroyed = true
    this.stopAllAnimations();
    this.stopAnimationFrame()
    this.onBeforeDispose()
    this.uncacheAnimations()
    if (this.gemChecker) {
      this.gemChecker.dispose();
      this.gemChecker = null;
    }
    if (this.scene) {
      this.scene.dispose()
      this.scene = null
    }
    if (this.camera) {
      this.camera.dispose()
      this.camera = null
    }
    if (this.controls) {
      this.controls.dispose()
      this.controls = null
    }
    if (this.renderer) {
      this.renderer.domElement.parentNode.removeChild(this.renderer.domElement)
      this.renderer.dispose()
      this.renderer = null
    }

    window.removeEventListener('orientationchange', this.onOrientationChange, false)

    this.clock = null
    this.loader = null
    this.manager = null;
    this.options = null
    this.onDisposed()

  }

  onBeforeDispose() {}

  onDisposed() {}
}